import React from "react";
import Layout from "../layouts/Default";
import { Link } from "react-router-dom";

export default () => {
  return (
    <Layout title="Page not found">
      <div className="p404">
        <div className="p404_content">
          <h1>404</h1>
          <h2>Page not found</h2>
          <Link to="/">Go back to home page</Link>
        </div>
      </div>
    </Layout>
  );
};
